import useAuthContext from "contexts/Auth/useAuthContext";
import {Auth, CodeAuth, ForgotPassword, ResetPassword, Signup} from "pages/auth";
import {FC} from "react";
import {Navigate, Route, Routes} from "react-router";

const AuthRouter: FC = () => {
  const auth = useAuthContext();

  if (auth) {
    return <Navigate to="/" />;
  }

  return (
    <Routes>
      <Route index element={<Auth />} />
      <Route path="signup" element={<Signup />} />
      <Route path="code/:code" element={<CodeAuth />} />
      <Route path="forgot" element={<ForgotPassword />} />
      <Route path="reset-password" element={<ResetPassword />} />
      <Route path="*" element={<Navigate to="/auth" replace />} />
    </Routes>
  );
};

export default AuthRouter;
